



































































































import {Vue, Component} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class Stalci extends mixins(ComponentBaseMixin) {
  isBusySave = false;
  stalci = [];
  stalak = {id: 0, code: '', group: '', image: '', name: '', publicID: ''};
  columns = [];
  tableOptions = {
    pagination: true,
    onClickRow: row => this.onClickRow(row)
  };

  async created() {
    this.columns = [
      {field: 'image', title: '', formatter: this.imageFormatter, width: 80},
      {field: 'code', title: this.$i18n.t('oznaka')},
      {field: 'group', title: this.$i18n.t('grupa')},
      {field: 'name', title: this.$i18n.t('naziv')}
    ];
  }

  mounted() {
    (<any>this.$refs.observer).validate();
    this.ucitajStalke();
  }

  async ucitajStalke() {
    this.stalci = [];
    let table = $('#displaysTable');
    try {
      table.bootstrapTable('showLoading');
      const {data} = await this.axios.get('api/GetAllRacks');
      this.stalci = data;
    } catch (e) {
      table.bootstrapTable('hideLoading');
      this.showError('greskaPrilikomUcitavanja');
    } finally {
      table.bootstrapTable('hideLoading');
    }
  }

  imageFormatter(value, row) {
    return value ? '<img src="' + value + '" height="32">' : ''
  }

  noviStalak() {
    this.stalak = {id: 0, code: '', group: '', image: '', name: '', publicID: ''};
  }

  async sacuvajStalak() {
    const valid = await (<any>this.$refs.observer).validate();
    if (valid) {
      try {
        this.isBusySave = true;
        await this.axios.post('api/SaveRack', this.stalak);
        await this.ucitajStalke();
        this.showInfo('podaciUspesnoSacuvani');
      } catch (e) {
        this.isBusySave = false;
        this.showError('neuspesnoCuvanjePodataka');
      } finally {
        this.isBusySave = false;
      }
    } else {
      this.showInfo('nisu sva obavezna polja popunjena');
    }
  }

  onClickRow(row) {
    this.stalak = row;
  }
}
